import React from "react";

import {
  Badge,
  Card,
  Icon,
  LabelledValue,
  Spacing,
  Title,
} from "@sicredi/react";
import { Product } from "#/types";
import { COMPANIES, PAGE, PLAN_STATUS, PRODUCTS_NAMES } from "#/constants";
import { GlobalContext } from "#/context/Global";
import { useHistory } from "react-router-dom";
import "./style.scss";

const color: {
  [PLAN_STATUS.FINISHED]: "success";
  [PLAN_STATUS.CANCELED]: "danger";
} = {
  [PLAN_STATUS.FINISHED]: "success",
  [PLAN_STATUS.CANCELED]: "danger",
};

const statusLabel = {
  [PLAN_STATUS.FINISHED]: "ativo",
  [PLAN_STATUS.CANCELED]: "cancelado",
};

export const PlanCard: React.FC<{ product: Product }> = ({ product }) => {
  const { dispatch, ActionTypes } = GlobalContext();

  const history = useHistory();

  function goToPlanPage() {
    dispatch({ type: ActionTypes.SET_PRODUCT, payload: product });
    history.push(PAGE.MY_PLAN.ROOT());
  }

  return (
    <Card
      data-testid="plan-card"
      header={{
        leftComponent: (
          <Title appearance="primary" as="h3">
            Plano {PRODUCTS_NAMES[product.product]}
          </Title>
        ),
        rightComponent: <Icon name="chevron-right" appearance="primary" />,
      }}
      appearance="bordered"
      onClick={() => goToPlanPage()}
      status={color[product.status as keyof typeof color]}
    >
      <LabelledValue>
        <LabelledValue.Item
          label={
            product.company === COMPANIES.DOCWAY ? "Telemedicina" : "Operadora"
          }
          value={product.companyLabel}
        />
      </LabelledValue>
      <Spacing appearance="small" />
      <Badge
        aria-label="Status"
        appearance={color[product.status as keyof typeof color]}
      >
        {statusLabel[product.status as keyof typeof color]}
      </Badge>
    </Card>
  );
};

export default PlanCard;
